import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

// organism — DWR top bar (sticky). Tre varianti mutuamente esclusive:
//   - default  → builder (sfondo paper + bordo rule + testo ink)
//   - hub      → CharacterViewPage (stesso stile default, z-index ≥ aside)
//   - levelup  → flusso level-up (sfondo ink invertito + testo paper-bright)
// Slots: brand (sinistra), center (centrato), actions (destra).
// Vedi mockup .topbar / .topbar--hub / .topbar--levelup
// (dev-workspace/mockups/.../project/styles.css righe 163-201 + 2101-2128).

type AppTopbarVariant = 'default' | 'hub' | 'levelup';

interface AppTopbarProps {
  variant?: AppTopbarVariant;
  brand?: ReactNode;
  center?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

const VARIANT_CLASSES: Record<AppTopbarVariant, string> = {
  default: 'bg-paper text-ink border-rule',
  hub: 'bg-paper text-ink border-rule',
  levelup: 'bg-ink text-paper-bright border-ink',
};

export function AppTopbar({
  variant = 'default',
  brand,
  center,
  actions,
  className,
}: AppTopbarProps) {
  return (
    <header
      className={cn(
        // h-14 (56px) fissa per stabilizzare lo sticky top dei layer figli
        // (StepNav, Aside) che si ancorano a 56px. Su mobile gli slot brand /
        // center / actions sono compressi per restare entro 56px senza wrap
        // (fix mobile critical 2026-05-17: center hidden sotto md, brand
        // compatto e actions con icon-only o testo ridotto).
        'sticky top-0 z-20 flex h-14 items-center gap-3 border-b px-3 sm:gap-4 sm:px-6',
        VARIANT_CLASSES[variant],
        className,
      )}
    >
      {brand ? <div className="flex min-w-0 items-center gap-2">{brand}</div> : null}
      {center ? (
        <div className="hidden flex-1 truncate text-center text-[0.95rem] md:block">{center}</div>
      ) : null}
      {actions ? <div className="ml-auto flex flex-shrink-0 gap-2">{actions}</div> : null}
    </header>
  );
}
